import { Flex } from '@byecode/ui'
import { useAtomData } from '@lighthouse/shared'
import { useCallback } from 'react'

import { applicationSettingAtom } from '@/atoms/application/state'

import { NotAllow } from '../components/NotAllow'
import { CONDITION_OPTIONS } from '../constants'
import { VersionCard } from '../VersionCard'
import { CoreIndicators } from './CoreIndicators'
import { GeographicalDistribution } from './GeographicalDistribution'
import { TrafficSource } from './TrafficSource'
import { TrafficTrends } from './TrafficTrends'

export const AnalyzeTraffic = () => {
    const isUsedCustomDomain = useAtomData(
        applicationSettingAtom,
        useCallback(s => !!s?.domain.isUsedCustomDomain && !!s?.domain.customDomain, [])
    )

    if (isUsedCustomDomain) {
        return <NotAllow />
    }

    return (
        <Flex direction="column" gap="20px">
            <VersionCard />
            <CoreIndicators defaultChecked={CONDITION_OPTIONS.map(item => item.value)} />
            <TrafficTrends />
            <TrafficSource />
            <GeographicalDistribution />
        </Flex>
    )
}
